<template>
    <div>
        <v-layout row pa-3>
            <h2>Generic Informations</h2>
        </v-layout>


      <v-layout row px-3 v-if="trend.tech_category !== ''">
        <p class="mb-1"><strong>Tech Category</strong>:</p>
      </v-layout>
      <v-layout row px-3 v-if="trend.tech_category.length !== ''">
        <ul>
          <li>{{ trend.tech_category }}</li>
        </ul>
      </v-layout>

      <v-layout row pt-3 px-3 v-if="trend.biz_category.length !== 0">
        <p class="mb-1"><strong>Biz Category</strong>:</p>
      </v-layout>
      <v-layout row px-3 v-if="trend.biz_category.length !== 0">
        <ul>
          <li v-for="biz in trend.biz_category">{{ biz }}</li>
        </ul>
      </v-layout>

      <v-layout row pt-3 px-3 v-if="trend.description !== ''">
        <p class="mb-1"><strong>Description</strong>:</p>
      </v-layout>
      <v-layout row px-3 v-if="trend.description !== ''">
        <p v-html="trend.description"></p>
      </v-layout>

      <v-layout v-if="plotshow && formatted_data.length > 0" row wrap justify-center>
          <vue-plotly :data="formatted_data" :layout="plot_layout" :display-mode-bar="false" :options="plot_options"></vue-plotly>
      </v-layout>

      <v-layout class="no-trend-yet" v-else row wrap justify-center>
        <h2>No trend data yet.</h2>
      </v-layout>

      <v-layout row pa-3>
      <DocumentList :trend="trend"></DocumentList>
      </v-layout>
      <v-layout row pa-3>
      <StartupList :trend="trend"></StartupList>
      </v-layout>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import store from "@/store";
    import VuePlotly from '@statnett/vue-plotly'
    import TimeService from "../../helpers/TimeService";
    import ApiService from "@/helpers/APIService";
    import DocumentList from "./DocumentList";
    import StartupList from "./StartupList";
    import UrlsService from "@/helpers/UrlsService";

    export default {
        name: "TrendDetails",
        components: {DocumentList, VuePlotly, StartupList},
        props: {
          trend: {
            type: Object,
            required: true
          }
        },
        data() {
            return {
              trend_data: {},
              formatted_data: [],
              plotshow: false,
              /*
              trend_data: {
                statistics: {
                  x: ["1961-01-01","1961-02-01","1961-03-01","1961-04-01"],
                  y: [432, 491, 494, 503],
                  type:"scatter",
                  name: "Real"
                },
                predictions: {
                  x: ["1961-04-01", "1961-05-01","1961-06-01","1961-07-01","1961-08-01", "1961-09-01"],
                  y: [503, 504, 503, 506, 508, 510],
                  confidence:{
                    y_u: [508, 510, 509, 512, 514, 513],
                    y_l: [500, 499, 498, 500, 501, 503]
                  },
                  type:"scatter",
                  name:"Predicted"
                }
              },*/
              plot_layout:{
                yaxis: {
                  title: {
                    text: 'Published articles',
                  }
                },
                xaxis: {
                  title: {
                    text: 'Time',
                  }
                },
                autosize: false,
              },
              plot_options: {
                displayModeBar: false,
                responsive: true
              }
            }
        },
        created() {
          this.initialize()
        },
        computed: {
            ...mapGetters("RadarState", {
                    labels: "getTechClassesLabels",
                    colors: "getTechClassesColors",
                }
            ),
        },
        watch: {
          /*
          trend_data: {
            handler(){
              if(this.trend_data !== {}){
                this.format_data()
              }
            },
            deep: true
          },
          */
        },
        methods: {
          initialize () {

             let requestUrl = {
                url: UrlsService.getTrendHistory,
                timeout: TimeService.secondsToMillis(0),
              };

              ApiService.superadmin(requestUrl,  {title: this.trend.title}, "post")
                  .then ( response => {

                    if(response !== null){
                      this.trend_data = response
                      if(this.trend_data !== {}){
                        this.format_data()
                      }
                      this.plotshow = true
                    }else{
                      this.plotshow = false
                    }
                  })
                  .catch ( error => { console.log(error) } )
            },
          format_data() {
            /*
              Si occupa di formattare i dati da dare in pasto a plotly per mostrare il grafico.
              I dati statistici sono obbligatori mentre i dati sulle predizioni sono opzionali
             */

            if(!"statistics" in this.trend_data){
              return;
            }
            let real = this.trend_data["statistics"]
            real["type"] = "scatter"
            real["name"] = "Real"

            this.formatted_data.push(real);

            let predictions;
            //let index_negative = []
            if ("predictions" in this.trend_data){
              predictions = this.trend_data["predictions"]
              predictions["type"] = "scatter"
              predictions["name"] = "Predictions"
              // To avoid y prediction go negative
              /*
              index_negative = predictions["y"].reduce(function(arr, y, i) {
                if (y < 0){
                  predictions["y"][i] = 0;
                  arr.push(i);
                }
                return arr;
              }, [])
              */
              predictions["y"] = predictions["y"].map(y => {
                if(y < 0) return 0
                else return y
              })
              this.formatted_data.push(predictions);
            }else{
              return;
            }

            if (!"confidence" in this.trend_data["predictions"]){
              return
            }

            let confidence = this.trend_data["predictions"]["confidence"]
            let prediction_reverse = [...predictions["x"]].reverse()

            // To avoid y confidence go negative
            //index_negative.forEach(index => confidence["y_u"][index] = 0)
            //index_negative.forEach(index => confidence["y_l"][index] = 0)
            confidence["y_u"] = confidence["y_u"].map(y => {
              if(y < 0) return 0
              else return y
            })
            confidence["y_l"] = confidence["y_l"].map(y => {
              if(y < 0) return 0
              else return y
            })
            let y_confidence_reverse = [...confidence["y_l"]].reverse()

            this.formatted_data.push(
              {
                x: predictions["x"].concat(prediction_reverse),
                y: confidence["y_u"].concat(y_confidence_reverse),
                name: "Confidence",
                fill: 'toself',
                fillcolor: 'rgba(0,100,80,0.2)',
                hoverinfo: "skip",
                showlegend: true,
                line: {color: "transparent"},
              }
            )
          }
        }
    }
</script>

<style scoped>
  .no-trend-yet{
    height: 300px;
    align-items: center;
  }
</style>
